import React, { Fragment, useEffect, useState } from 'react';

import {
  useRESTDataCache,
  PlacesProvider,
  ResultProvider,
} from '@atresmedia/elections_modules_library/dist/dataProvider';
import {
  TYPES,
  SUBTYPES,
  ELECTION_SPAIN_GENERAL_EUROPE,
} from '@atresmedia/elections_modules_library/dist/envs';

import CustomMap from '@atresmedia/elections_modules_library/dist/components/homeMap/customMap';
import AtresBarChart from '@atresmedia/elections_modules_library/dist/components/charts/atresBarChart';
import AtresPieChart from '@atresmedia/elections_modules_library/dist/components/charts/atresPieChart';
import TableCompare from '@atresmedia/elections_modules_library/dist/components/table';
import Tag from '@atresmedia/elections_modules_library/dist/components/tag';
import Tags from '@atresmedia/elections_modules_library/dist/components/tags';
import ElTabs from '@atresmedia/elections_modules_library/dist/components/elTabs';
import Autocomplete from '@atresmedia/elections_modules_library/dist/components/autocomplete';

import { getRoute, navigateTo } from '../../utils';
import { getSite } from '../moduleGenerator/utils';
import { PROPERTIES_JSON } from '../../core/constants';

const Main = ({
  community,
  history,
  communityName,
  autocomple,
  setAutocomple,
  onProvinceChange,
  excludes,
  reload,
  placeId,
  year,
  type,
  electionNumber,
  chartType,
  province,
  dataResult,
  provincePlace,
  showSelectedPlace,
  selectedPlace,
  allRegions,
  mapData,
  changeMapSelection,
  elSubtype,
  tabsTitle,
  resultOrigin,
  PactometroCheckSimple,
  goToDetails,
}) => {
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  const [rows, setRows] = useState([]);
  const [autocomplePro, setAutocomplePro] = useState('');
  let Chart = chartType === 'arc' ? AtresPieChart : AtresBarChart;
  const site = getSite();

  useEffect(() => {
    if (params) {
      setRows(params.sites[site].views.home.rows);
    }
  }, [params]);

  if (!params || !rows) {
    return <div>Loading...</div>;
  }
  const content = rows.map((row) => (
    <div className={row.class}>
      {row.columns.map((column) => (
        <div className={column.class}>
          {column.components.map((item) => {
            return (
              <div className={item.class || ''} key={item.module}>
                {item.module === 'SELECTORS' && (
                  <Fragment>
                    <div className="row-places">
                      <div className="col-places">
                        <PlacesProvider
                          // name={autocomple}
                          sortby="name"
                          type="PROVINCE"
                          parentId={community}
                        >
                          {(data) => {
                            return (
                              <Autocomplete
                                results={[
                                  {
                                    ineId: '-1',
                                    name: `Todo ${communityName}`,
                                  },
                                  ...data.filter((d) => {
                                    return autocomple
                                      ? d.name
                                          .toLocaleLowerCase()
                                          .includes(
                                            autocomple.toLocaleLowerCase()
                                          )
                                      : d;
                                  }),
                                ]}
                                onChange={(value) => setAutocomple(value)}
                                onSelect={(select) => {
                                  if (onProvinceChange) {
                                    let place =
                                      select.ineId > 0
                                        ? select
                                        : {
                                            parentId: community,
                                            grandpaId: ELECTION_SPAIN_GENERAL_EUROPE,
                                            name: communityName,
                                          };
                                    return onProvinceChange(
                                      null,
                                      place,
                                      null,
                                      excludes
                                    );
                                  }
                                  select.typePlace === 'REGION'
                                    ? navigateTo(
                                        history,
                                        reload,
                                        `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${select.ineId}/resultados.html`,
                                        select,
                                        false,
                                        excludes,
                                        params
                                      )
                                    : navigateTo(
                                        history,
                                        reload,
                                        `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${select.parentId}/${select.ineId}/resultados.html`,
                                        select,
                                        true,
                                        excludes,
                                        params
                                      );
                                  setAutocomple('');
                                }}
                                placeholder={'Busque provincia'}
                                showArrow
                                defaultValue={data.length > 0 && province}
                              />
                            );
                          }}
                        </PlacesProvider>
                      </div>
                      <div className="col-places">
                        <PlacesProvider
                          // name={autocomplePro}
                          sortby="name"
                          type="TOWN"
                          parentId={province}
                          grandParentId={province ? undefined : community}
                        >
                          {(data) => {
                            return (
                              <Autocomplete
                                results={[
                                  ...data.filter((d) => {
                                    return autocomplePro
                                      ? d.name
                                          .toLocaleLowerCase()
                                          .includes(
                                            autocomplePro.toLocaleLowerCase()
                                          )
                                      : d;
                                  }),
                                ]}
                                onChange={(value) => setAutocomplePro(value)}
                                onSelect={(select) => {
                                  if (onProvinceChange)
                                    return onProvinceChange(
                                      null,
                                      select,
                                      null,
                                      excludes
                                    );

                                  navigateTo(
                                    history,
                                    reload,
                                    `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${select.grandpaId}/${select.parentId}/${select.ineId}/resultados.html`,
                                    select,
                                    true,
                                    excludes,
                                    params
                                  );
                                  setAutocomplePro('');
                                }}
                                placeholder={'Busque municipio'}
                                showArrow
                              />
                            );
                          }}
                        </PlacesProvider>
                      </div>
                    </div>
                    <h2 className="selectedPlaceTitle">
                      <a
                        href={
                          provincePlace &&
                          getRoute(
                            {
                              parentId: community,
                              grandpaId: ELECTION_SPAIN_GENERAL_EUROPE,
                              name: communityName,
                              path: 'cataluna',
                            },
                            community,
                            excludes,
                            reload,
                            params
                          )
                        }
                        className="selectedCommunityTitle"
                        onClick={(event) => {
                          if (onProvinceChange) {
                            event.preventDefault();
                            return onProvinceChange(
                              null,
                              {
                                parentId: community,
                                grandpaId: ELECTION_SPAIN_GENERAL_EUROPE,
                              },
                              null,
                              excludes
                            );
                          }
                        }}
                      >
                        {communityName}
                      </a>
                      {showSelectedPlace && (
                        <span className="selectedTownTitle">
                          {selectedPlace.name}
                        </span>
                      )}
                    </h2>
                  </Fragment>
                )}
                {item.module === 'RESULTADOS' && (
                  <Chart
                    data={dataResult.partiesResult || []}
                    dataKey={'seats'}
                    isSenate={elSubtype === SUBTYPES.SENATE}
                    showMajorityLine={
                      type !== TYPES.REGIONAL
                        ? !province && !community
                        : !Boolean(province)
                    }
                    showLabel
                    unitLabel={null}
                    labelAbrv=""
                    seatTotal={dataResult.totalSeats || 0}
                  />
                )}
                {item.module === 'RESULTADOS_DOBLES' && (
                  <ResultProvider
                    active={
                      resultOrigin &&
                      resultOrigin.historic &&
                      resultOrigin.historic.active
                    }
                    year={
                      resultOrigin &&
                      resultOrigin.historic &&
                      resultOrigin.historic.year
                    }
                    type={type}
                    subtype={elSubtype}
                    electionPlace={placeId}
                    electionNumber={
                      resultOrigin &&
                      resultOrigin.historic &&
                      resultOrigin.historic.numElection
                    }
                    placeId={province || community}
                  >
                    {(oldData) => {
                      return (
                        <Chart
                          chartInfo1={{
                            innerRadius: 125,
                            outerRadius: 155,
                            label: 2021,
                          }}
                          chartInfo2={{
                            innerRadius: 90,
                            outerRadius: 120,
                            label: 2020,
                          }}
                          data={dataResult.partiesResult || []}
                          data2={oldData.partiesResult || []}
                          dataKey={'seats'}
                          isSenate={elSubtype === SUBTYPES.SENATE}
                          showMajorityLine={
                            type !== TYPES.REGIONAL
                              ? !province && !community
                              : !Boolean(province)
                          }
                          showLabel
                          unitLabel={null}
                          labelAbrv=""
                          seatTotal={dataResult.totalSeats || 0}
                        />
                      );
                    }}
                  </ResultProvider>
                )}
                {item.module === 'HOME_DOBLE' && (
                  <ResultProvider
                    active={
                      resultOrigin &&
                      resultOrigin.historic &&
                      resultOrigin.historic.active
                    }
                    year={
                      resultOrigin &&
                      resultOrigin.historic &&
                      resultOrigin.historic.year
                    }
                    type={type}
                    subtype={elSubtype}
                    electionPlace={placeId}
                    electionNumber={
                      resultOrigin &&
                      resultOrigin.historic &&
                      resultOrigin.historic.numElection
                    }
                    placeId={province || community}
                  >
                    {(oldData) => {
                      return (
                        <Chart
                          data={dataResult.partiesResult || []}
                          data2={oldData.partiesResult || []}
                          dataKey={'seats'}
                          isSenate={elSubtype === SUBTYPES.SENATE}
                          showMajorityLine={
                            type !== TYPES.REGIONAL
                              ? !province && !community
                              : !Boolean(province)
                          }
                          showLabel
                          unitLabel={null}
                          labelAbrv=""
                          seatTotal={oldData.totalSeats || 0}
                        />
                      );
                    }}
                  </ResultProvider>
                )}
                {item.module === 'MAP' && (
                  <Fragment>
                    <CustomMap
                      allRegions={allRegions}
                      selectedPlace={selectedPlace}
                      partiesWinners={
                        dataResult ? dataResult.partiesWinners : []
                      }
                      native={true}
                      maps={mapData}
                      isRegional={type === TYPES.REGIONAL}
                      isFiltered={
                        type !== TYPES.REGIONAL
                          ? Boolean(community)
                          : Boolean(province)
                      }
                      currentCommunity={community}
                      onChange={changeMapSelection}
                    />
                  </Fragment>
                )}
                {item.module === 'TABS_CONTAINER' && (
                  <ElTabs titles={item.data.tabs.map((tab) => tab.title)}>
                    {item.data.tabs.map((tab) => {
                      return (
                        <ResultProvider
                          active={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.active
                          }
                          year={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.year
                          }
                          type={type}
                          subtype={elSubtype}
                          electionPlace={placeId}
                          electionNumber={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.numElection
                          }
                          placeId={province || community}
                        >
                          {(oldData) => {
                            return (
                              <Fragment>
                                {tab.component === 'TABLE' && (
                                  <TableCompare
                                    className="current"
                                    data={
                                      (tab.data.year ===
                                      params.sites[site].generator.config.year
                                        ? dataResult.partiesResult
                                        : oldData.partiesResult) || []
                                    }
                                    details={
                                      elSubtype === SUBTYPES.CONGRESS ||
                                      type === TYPES.REGIONAL
                                    }
                                    isSenate={elSubtype === SUBTYPES.SENATE}
                                  />
                                )}
                                {tab.component === 'RESULTADOS' && (
                                  <div>
                                    <div className="graph_with_leyend">
                                      <Chart
                                        data={
                                          (tab.data.year === params.year
                                            ? dataResult.partiesResult
                                            : oldData.partiesResult) || []
                                        }
                                        dataKey={'seats'}
                                        isSenate={elSubtype === SUBTYPES.SENATE}
                                        showMajorityLine={
                                          type !== TYPES.REGIONAL
                                            ? !province && !community
                                            : !Boolean(province)
                                        }
                                        showLabel
                                        labelAbrv=""
                                        seatTotal={dataResult.totalSeats || 0}
                                        unitLabel={null}
                                      />
                                      {/* community === "R16" && (
                                        <p className="graph_leyend">
                                          *Los datos de PP y Cs (0 escaños) se
                                          representan sumados en 2017.
                                        </p>
                                      ) */}
                                    </div>
                                  </div>
                                )}

                                {tab.component === 'PACTOS' && (
                                  <div className="pactometroWrapper">
                                    <ResultProvider
                                      active={
                                        resultOrigin &&
                                        resultOrigin.primary &&
                                        resultOrigin.primary.active
                                      }
                                      year={
                                        resultOrigin &&
                                        resultOrigin.primary &&
                                        resultOrigin.primary.year
                                      }
                                      type={type}
                                      placeId={placeId}
                                      subtype={
                                        type === TYPES.GENERAL
                                          ? SUBTYPES.CONGRESS
                                          : SUBTYPES.SINGLE
                                      }
                                      electionPlace={placeId}
                                      electionNumber={electionNumber}
                                    >
                                      {(generalData) => (
                                        <div className="pactometroScroll">
                                          <PactometroCheckSimple
                                            totalSeat={generalData.totalSeats}
                                            seatData={
                                              generalData.partiesResult || []
                                            }
                                          />
                                        </div>
                                      )}
                                    </ResultProvider>
                                  </div>
                                )}
                              </Fragment>
                            );
                          }}
                        </ResultProvider>
                      );
                    })}
                  </ElTabs>
                )}
                {item.module === 'TAGS' && (
                  <Fragment>
                    <p className="tags-title">
                      Resultado de las elecciones catalanas en:
                    </p>
                    <Tags>
                      <PlacesProvider
                        type="TOWN"
                        grandParentId={!province ? community : null}
                        parentId={province || community}
                        size={10}
                        sortby="main"
                      >
                        {(data) =>
                          data &&
                          data.slice(0, 10).map((d) => (
                            <Tag
                              key={`${d.ineId}-${d.name}`}
                              onClick={(event) => {
                                event.preventDefault();
                                goToDetails(d, event);
                              }}
                              native
                              route={getRoute(
                                d,
                                true,
                                excludes,
                                reload,
                                params
                              )}
                            >
                              {d.name}
                            </Tag>
                          ))
                        }
                      </PlacesProvider>
                    </Tags>
                  </Fragment>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  ));

  return <Fragment>{content}</Fragment>;
};

export default Main;
